<ion-app [class]="platformType">
  <ion-split-pane
    *ngIf="isWebview"
    contentId="main-content"
    class="webviewHolder"
    autoHide="false"
  >
    <ion-menu
      *ngIf="userIsLogged$"
      side="start"
      class="bepatient-left-menu"
      menuId="leftMenu"
      type="overlay"
      contentId="main-content"
    >
      <ion-content #leftMenuContent>
        <ng-container *ngIf="improvedMenu$ | async as improvedMenu">
          <img
            [src]="
              sanitizer.bypassSecurityTrustResourceUrl(
                improvedMenu.instanceLogo
              )
            "
          />
          <div class="main-button-container">
            <bepatient-menu-main-button
              *ngFor="let button of improvedMenu.mainButtons; let i = index"
              label="{{ button.labelTranslateKey | translate }}"
              [icon]="button.icon"
              [color]="improvedMenu.color"
              [selected]="
                button === selectedMenuButton ||
                (!selectedMenuButton && i === 0)
              "
              [reversed]="button.reversed"
              [iconColor]="button.iconColor"
              [notifications]="button.notifications"
              [style.flexBasis]="button.flexBasisStyle"
              (click)="menuButtonClick(button)"
            >
            </bepatient-menu-main-button>
          </div>

          <bepatient-menu-secondary-button-container
            *ngFor="let group of improvedMenu.secondaryButtonGroups"
            [title]="group.title"
            [color]="improvedMenu.color"
          >
            <bepatient-menu-secondary-button
              *ngFor="let button of group.buttons"
              label="{{ button.label || button.labelTranslateKey | translate }}"
              [icon]="button.icon"
              [color]="improvedMenu.color"
              [selected]="button === selectedMenuButton"
              (click)="menuButtonClick(button)"
            >
            </bepatient-menu-secondary-button>
          </bepatient-menu-secondary-button-container>
        </ng-container>
      </ion-content>
    </ion-menu>

    <ion-menu
      side="end"
      class="bepatient-right-menu"
      menuId="rightMenu"
      contentId="main-content"
      [swipeGesture]="false"
    >
      <ion-header>
        <router-outlet name="rightMenuHeader"></router-outlet>
      </ion-header>
      <ion-content>
        <router-outlet name="rightMenuContent"></router-outlet>
      </ion-content>
      <ion-footer>
        <router-outlet name="rightMenuFooter"></router-outlet>
      </ion-footer>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
